export const aboutAdvantages = [
  {
    id: 'adv-1',
    type: 'dark' as const,
    icon: '🔍',
    title: '全网监控',
    description: '7×24小时不间断扫描全网社交平台，第一时间捕捉网红、明星最新动态，确保不遗漏任何一个劲爆大瓜。',
  },
  {
    id: 'adv-2',
    type: 'image' as const,
    image: 'https://readdy.ai/api/search-image?query=Real%20time%20data%20dashboard%20with%20warm%20coral%20and%20amber%20glowing%20elements%2C%20modern%20monitoring%20center%20aesthetic%2C%20abstract%20data%20visualization%2C%20soft%20atmospheric%20lighting%2C%20futuristic%20yet%20warm%20design&width=600&height=400&seq=about-adv-02&orientation=landscape',
    category: '核心优势',
    title: '实时更新',
  },
  {
    id: 'adv-3',
    type: 'text-image' as const,
    title: '社区互动',
    description: '百万吃瓜群众在线互动，投票评选每日瓜王、每周热点，让你不再是一个人默默吃瓜。',
    image: 'https://readdy.ai/api/search-image?query=Engaged%20online%20community%20with%20warm%20coral%20and%20cream%20color%20palette%2C%20social%20media%20interaction%20concept%2C%20abstract%20connected%20network%20nodes%2C%20friendly%20modern%20design%2C%20soft%20atmospheric%20lighting&width=600&height=400&seq=about-adv-03&orientation=landscape',
  },
];

export const reputationComments = [
  {
    id: 1,
    name: '资深吃瓜人',
    handle: '@lao_chigua',
    avatar: '老',
    comment: '关注黑料吃瓜网三年了，信息更新真的快。很多其他平台还没发的料，这里已经出详细整理了。吃瓜就认准这一家！',
  },
  {
    id: 2,
    name: '媒体人小张',
    handle: '@zhang_media',
    avatar: '张',
    comment: '作为一个媒体从业者，我每天必看黑料吃瓜网。他们的信息来源广泛，整理得也很专业，是我找选题的重要参考。',
  },
  {
    id: 3,
    name: '娱乐博主',
    handle: '@yule_blog',
    avatar: '娱',
    comment: '黑料吃瓜网的内容质量在同类平台中绝对是顶尖的。不造谣不传谣，每条爆料都有理有据，这才是专业吃瓜的态度。',
  },
  {
    id: 4,
    name: '理性吃瓜群众',
    handle: '@lixing_gua',
    avatar: '理',
    comment: '从最初的路人到现在每天必刷，黑料吃瓜网已经成了我生活的一部分。界面清爽，内容靠谱，推荐给了好多朋友。',
  },
  {
    id: 5,
    name: '深夜八卦党',
    handle: '@shenye_bagua',
    avatar: '深',
    comment: '熬夜吃瓜必备！更新速度快到令人发指，经常半夜刷新就有新内容。编辑部是不睡觉的吗？辛苦了！',
  },
  {
    id: 6,
    name: '娱乐圈老兵',
    handle: '@yule_veteran',
    avatar: '圈',
    comment: '在娱乐圈摸爬滚打二十年，我可以负责任地说，黑料吃瓜网的很多内幕消息是其他平台根本拿不到的。信息源非常硬核。',
  },
];

export const aboutStats = [
  { value: '2019', label: '成立年份' },
  { value: '50+', label: '覆盖平台' },
  { value: '3,200万', label: '累计阅读' },
  { value: '12,000+', label: '独家爆料' },
];